var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutShip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 217,
    viewBox: "0 0 348 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158 216V1H226.759H277H347V216H158Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.759 1H158V216H347V1H277M226.759 1V54.3245H277V1M226.759 1H277",
    stroke: "#EADDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 216V51H69.7595H120H190V216H1Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7595 51H1V216H190V51H120M69.7595 51V94.9235H120V51M69.7595 51H120",
    stroke: "#EADDDD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutShip);
export default __webpack_public_path__ + "static/media/about-ship.bc2a4f5221dfb432786792089f10d5be.svg";
export { ForwardRef as ReactComponent };